import { useCallback, useState } from "react";

import { type HistoryItem } from "../types";

/**
 * 送信履歴フック
 */
export function useFieldUpdateHistory() {
    const [history, setHistory] = useState<HistoryItem[]>([]);

    // 履歴を追加して時間順ソート
    const addHistory = useCallback((items: HistoryItem[] | HistoryItem) => {
        setHistory(prev => prev.concat(Array.isArray(items) ? items : [items]).sort((i1, i2) => {
            const t1 = i1.timestamp ? i1.timestamp.getTime() : 0;
            const t2 = i2.timestamp ? i2.timestamp.getTime() : 0;
            return t1 - t2;
        }));
    }, []);

    // 履歴をクリア
    const clearHistory = useCallback(() => setHistory([]), []);

    return {
        history,
        addHistory,
        clearHistory,
    } as const;
}

export default useFieldUpdateHistory;